module.exports = __webpack_public_path__ + "static/media/document-hand-held-writing.dec16792.svg";